import { useLayoutEffect } from 'react';
import { redirect, useSearchParams } from 'react-router-dom';
import { useAuthState } from 'state/client-middleware';
import { ResetpasswordForm } from 'features/auth/components/reset-password';
import { useMobileDeepLink } from 'hooks/use-mobile-deep-link';
import { MobileDeepLinkLoader } from 'components/core/mobile-deep-link-loader';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') ?? '';
  const { isMounted, isAuthenticated } = useAuthState();

  const deepLinkUrl = `${process.env.REACT_APP_PUBLIC_MOBILE_BUNDLE_ID}://reset-password/?code=${code}`;
  const { shouldShowFallback, isAttemptingDeepLink, isMobile } = useMobileDeepLink({
    deepLinkUrl,
    fallbackDelay: 2000,
  });

  useLayoutEffect(() => {
    if (isAuthenticated) redirect('/');
  }, [isAuthenticated]);

  if (!isMounted) return null;

  if (isMobile && isAttemptingDeepLink && !shouldShowFallback) {
    return <MobileDeepLinkLoader />;
  }

  return (
    <div className="flex flex-col gap-6 mb-4">
      <div>
        <div className="text-2xl font-bold text-high-emphasis">Reset password</div>
        <div className="flex gap-1 mt-1">
          <div className="text-sm font-normal text-medium-emphasis">
            Choose password to secure your account{' '}
          </div>
        </div>
      </div>

      <ResetpasswordForm code={code} />
    </div>
  );
}
